import { createApi } from '@reduxjs/toolkit/query/react';

import {
    Client,
    ClientProfile,
    REQUESTS_PATH
} from '@apis/clients/ClientsApi.types';
import { baseQueryWithIntercept } from '@apis/fetchBaseQuery';
import { AccountsSubAccounts } from '@apis/users/UsersApi.types';
import { RequestStatusWithData } from '@customTypes/api/api.types';

export const clientsApi = createApi({
    reducerPath: 'clientsApi',
    baseQuery: baseQueryWithIntercept,
    endpoints: (builder) => ({
        getClients: builder.query<RequestStatusWithData<Client[]>, void>({
            query: () => ({ url: REQUESTS_PATH.CLIENTS })
        }),
        getAccountsAndSubs: builder.query<AccountsSubAccounts, number>({
            query: (clientId) => ({
                url: `${REQUESTS_PATH.GET_ACCOUNTS_AND_SUBS}/${clientId}`
            })
        }),
        getClientProfiles: builder.query<
            RequestStatusWithData<ClientProfile[]>,
            number | undefined
        >({
            query: (clientId) => ({
                url: clientId
                    ? `${REQUESTS_PATH.GET_CLIENT_PROFILES}?clientId=${clientId}`
                    : REQUESTS_PATH.GET_CLIENT_PROFILES
            })
        })
    })
});

export const {
    useGetClientsQuery,
    useLazyGetAccountsAndSubsQuery,
    useLazyGetClientProfilesQuery
} = clientsApi;
